const DollarSignBtn = ({ onClick }: { onClick: () => void }) => {
  return (
    <button
      onClick={onClick}
      className="w-[1.375rem] h-[1.375rem] bg-black rounded-full flex justify-center items-center text-white text-xs text-opacity-50 cursor-default"
    >
      $
    </button>
  );
};

export default DollarSignBtn;
